import { render, staticRenderFns } from "./AppItem.vue?vue&type=template&id=681895de&scoped=true&"
import script from "./AppItem.vue?vue&type=script&lang=js&"
export * from "./AppItem.vue?vue&type=script&lang=js&"
import style0 from "./AppItem.vue?vue&type=style&index=0&id=681895de&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681895de",
  null
  
)

export default component.exports